import React, { useEffect, useRef } from "react";

const ADSENSE_CLIENT = "ca-pub-4013441362310675";

// Renders a real Google AdSense unit.
// - With Auto Ads enabled in the AdSense dashboard, Google places ads
//   automatically site-wide (the loader script lives in public/index.html).
// - Pass a `slot` id to render an explicit in-content ad unit at this position.
const AdSlot = ({ label = "Advertisement", height = "h-24 md:h-28", slot, format = "auto" }) => {
  const insRef = useRef(null);
  // A genuine AdSense ad-unit slot id is numeric. Named placeholders
  // (e.g. "home-top") are ignored so Auto Ads can place ads instead.
  const isRealSlot = typeof slot === "string" && /^\d+$/.test(slot);

  useEffect(() => {
    if (!isRealSlot) return;
    try {
      (window.adsbygoogle = window.adsbygoogle || []).push({});
    } catch (e) {
      // AdSense not loaded yet (e.g. blocked / preview) — ignore.
    }
  }, [isRealSlot]);

  // No explicit numeric slot: let Auto Ads handle placement, render nothing.
  if (!isRealSlot) return null;

  return (
    <div className="mx-auto max-w-6xl px-4 py-4 md:px-8" data-testid={`ad-slot-${slot}`}>
      <p className="mb-1 text-center font-display text-[10px] uppercase tracking-[0.3em] text-[#8a8a8a]">
        {label}
      </p>
      <ins
        ref={insRef}
        className="adsbygoogle"
        style={{ display: "block", minHeight: 90 }}
        data-ad-client={ADSENSE_CLIENT}
        data-ad-slot={slot}
        data-ad-format={format}
        data-full-width-responsive="true"
      />
    </div>
  );
};

export default AdSlot;
